import { useState } from 'react'

// `value` controls; without it the select keeps its own state, seeded by
// `defaultValue`. Going back from a value to `undefined` resets to empty, as
// antd's does — so `value={picked ?? undefined}` clears the field.
export const useSelectValue = <V>(
  value: V | undefined,
  defaultValue: V | undefined,
): readonly [V | undefined, (next: V | undefined) => void] => {
  const [inner, setInner] = useState(defaultValue)
  const [previous, setPrevious] = useState(value)
  if (previous !== value) {
    setPrevious(value)
    if (value === undefined) setInner(undefined)
  }
  return [value !== undefined ? value : inner, setInner]
}
